import { render } from "./BenefitComponent.vue?vue&type=template&id=a144ec78"
import script from "./BenefitComponent.vue?vue&type=script&lang=js"
export * from "./BenefitComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/home/BenefitComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a144ec78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a144ec78', __exports__)) {
    api.reload('a144ec78', __exports__)
  }
  
  module.hot.accept("./BenefitComponent.vue?vue&type=template&id=a144ec78", () => {
    api.rerender('a144ec78', render)
  })

}


export default __exports__